import React, { createContext, useContext, useState, useMemo } from 'react';  
import { jwtDecode } from 'jwt-decode';  
  
const AuthContext = createContext();  
  
export const AuthProvider = ({ children }) => {  
   const [user, setUser] = useState(() => {  
      const token = localStorage.getItem('token');  
      return token ? jwtDecode(token) : null; // Decode user data from token if it exists  
   });  
   const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token')); // Boolean indicating if token exists  
  
   const login = (token) => {  
      localStorage.setItem('token', token); // Store the token  
      const decoded = jwtDecode(token); // Decode user data  
      setUser(decoded); // Set user state  
      setIsAuthenticated(true); // Update authenticated state  
   };  
  
   const logout = () => {  
      localStorage.removeItem('token'); // Remove the token  
      setUser(null); // Clear user state  
      setIsAuthenticated(false); // Update authenticated state  
   };  
  
   // Memoize the context value to prevent unnecessary re-renders  
   const value = useMemo(() => ({  
      user,  
      isAuthenticated,  
      login,  
      logout,  
   }), [user, isAuthenticated]);  
  
   return (  
      <AuthContext.Provider value={value}>  
        {children}  
      </AuthContext.Provider>  
   );  
};  
  
export const useAuth = () => useContext(AuthContext);
